import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AdminRecordingLibraryComponent } from "@onsip/web/features/administrators/recording/recording-library.component";
import { RecordingContainerComponent } from "@onsip/web/features/administrators/recording/recordingContainer/recording-container.component";
import { RecordingSetupComponent } from "@onsip/web/features/administrators/recording/recordingSetup/recording-setup.component";

const routes: Routes = [
  {
    path: "",
    component: RecordingContainerComponent,
    children: [
      {
        path: "",
        runGuardsAndResolvers: "always",
        data: { title: "Recording library" },
        pathMatch: "full",
        component: AdminRecordingLibraryComponent
      },
      {
        path: "setup",
        runGuardsAndResolvers: "always",
        data: { title: "Add recording" },
        pathMatch: "full",
        component: RecordingSetupComponent
      }
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)]
})
export class RecordingRoutingModule {}
